// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/game/systems/*.ts
import * as m0 from './systems/fishing';
import * as m1 from './systems/spaces';
import * as m2 from './systems/villagers';
export const systemModules = [m0, m1, m2] as const;
